// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input-field {
  position: relative;
  display: flex;
  align-items: center;
  margin: var(--motes-padding) 0;
}
input-field input {
  width: 100%;
  height: 43px;
  border: solid 1px var(--motes-gray);
  background-color: var(--motes-white);
  border-radius: var(--border-radius);
  padding: var(--motes-padding);
  box-sizing: border-box;
  font-family: var(--text-font);
  font-size: 16px;
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  /* Internet Explorer 10-11 */
  /* Microsoft Edge */
  /* Remove the default 'x' in search fields  */
}
input-field input.with-side {
  padding-right: 30px;
}
input-field input.with-count {
  padding-right: 70px;
}
input-field input::placeholder {
  color: var(--motes-gray);
  opacity: 1; /* Firefox */
}
input-field input:-ms-input-placeholder {
  color: var(--motes-gray);
}
input-field input::-ms-input-placeholder {
  color: var(--motes-gray);
}
input-field input[type=search]::-webkit-search-decoration, input-field input[type=search]::-webkit-search-cancel-button, input-field input[type=search]::-webkit-search-results-button, input-field input[type=search]::-webkit-search-results-decoration {
  -webkit-appearance: none;
}
input-field svg-icon, input-field .character-count {
  position: absolute;
  right: var(--motes-padding);
  transition: 0.2s transform;
}
input-field .character-count {
  color: var(--motes-gray);
}
input-field svg-icon {
  color: var(--motes-black);
  cursor: pointer;
}
input-field svg-icon .svg-icon {
  display: flex;
}
input-field svg-icon:hover:not(.disabled) {
  transform: scale(1.2);
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/input-field/input-field.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACJ;AACI;EACI,WAAA;EACA,YAAA;EACA,mCAAA;EACA,oCAAA;EACA,mCAAA;EACA,6BAAA;EACA,sBAAA;EACA,6BAAA;EACA,eAAA;EAUA,yCAAA;EAMA,4BAAA;EAKA,mBAAA;EAKA,6CAAA;AArBR;AAHQ;EACI,mBAAA;AAKZ;AAFQ;EACI,mBAAA;AAIZ;AAAQ;EACI,wBAAA;EACA,UAAA,EAAA,YAAA;AAEZ;AAEQ;EACI,wBAAA;AAAZ;AAIQ;EACI,wBAAA;AAFZ;AAMQ;EAIE,wBAAA;AAPV;AAWI;EACI,kBAAA;EACA,2BAAA;EACA,0BAAA;AATR;AAYI;EACI,wBAAA;AAVR;AAaI;EACI,yBAAA;EACA,eAAA;AAXR;AAaQ;EACI,aAAA;AAXZ;AAcQ;EACI,qBAAA;AAZZ","sourcesContent":["input-field {\n    position: relative;\n    display: flex;\n    align-items: center;\n    margin: var(--motes-padding) 0;\n    \n    input {\n        width: 100%;\n        height: 43px;\n        border: solid 1px var(--motes-gray);\n        background-color: var(--motes-white);\n        border-radius: var(--border-radius);\n        padding: var(--motes-padding);\n        box-sizing: border-box;\n        font-family: var(--text-font);\n        font-size: 16px;\n\n        &.with-side {\n            padding-right: 30px;\n        }\n\n        &.with-count {\n            padding-right: 70px;\n        }\n\n        /* Chrome, Firefox, Opera, Safari 10.1+ */\n        &::placeholder {\n            color: var(--motes-gray);\n            opacity: 1; /* Firefox */\n        }\n\n        /* Internet Explorer 10-11 */\n        &:-ms-input-placeholder {\n            color: var(--motes-gray);\n        }\n\n        /* Microsoft Edge */\n        &::-ms-input-placeholder {\n            color: var(--motes-gray);\n        }\n\n        /* Remove the default 'x' in search fields  */\n        &[type=\"search\"]::-webkit-search-decoration,\n        &[type=\"search\"]::-webkit-search-cancel-button,\n        &[type=\"search\"]::-webkit-search-results-button,\n        &[type=\"search\"]::-webkit-search-results-decoration {\n          -webkit-appearance:none;\n        }\n    }\n\n    svg-icon, .character-count {\n        position: absolute;\n        right: var(--motes-padding);\n        transition: 0.2s transform;\n    }\n\n    .character-count {\n        color: var(--motes-gray);\n    }\n\n    svg-icon {\n        color: var(--motes-black);\n        cursor: pointer;\n\n        .svg-icon {\n            display: flex;\n        }\n\n        &:hover:not(.disabled) {\n            transform: scale(1.2);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
